import * as Sentry from "@sentry/gatsby";
const sentryDsn = process.env.GATSBY_SENTRY_DSN;
const sentryEnvironment = process.env.GATSBY_SENTRY_ENVIRONMENT;
const isSentryEnabled = process.env.GATSBY_SENTRY_ENABLED === "true";

Sentry.init({
  dsn: sentryDsn,
  sendDefaultPii: true,
  enabled: isSentryEnabled,
  environment: sentryEnvironment,
  enableLogs: true,
  sampleRate: sentryEnvironment === "production" ? 1.0 : 0.5,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "Non-fatal Error",
    "Network request failed",
    "Non-Error exception captured",
  ],
  denyUrls: [/extensions\//i, /^chrome:\/\//i, /gtm\.js/i, /facebook\.net/i],
});
